import { useState, useMemo } from 'react';

export interface CalendarTask {
  id: string;
  title: string;
  start: Date;
  end: Date;
  startAt?: Date | string;
  endAt?: Date | string;
  description?: string;
  calendarId?: string;
  isCompleted?: boolean;
  relatedContact?: {
    id: string;
    name: string;
  };
  kind?: 'task';
}

export interface UseCalendarTasksType {
  tasks: CalendarTask[];
  setTasks: React.Dispatch<React.SetStateAction<CalendarTask[]>>;
  filteredTasks: CalendarTask[];
}

export const useCalendarTasksInitialState: UseCalendarTasksType = {
  tasks: [],
  setTasks: () => {},
  filteredTasks: [],
};

export const useCalendarTasks = (activeCalendarIds: string[]): UseCalendarTasksType => {
  const [tasks, setTasks] = useState<CalendarTask[]>([]);

  // Filtrar tareas por calendarios activos
  const filteredTasks = useMemo(() => {
    if (!activeCalendarIds?.length) return tasks;
    return tasks.filter((task) => task.calendarId && activeCalendarIds.includes(task.calendarId));
  }, [tasks, activeCalendarIds]);

  // 🔒 ESTABILIZACIÓN: Memoizar el objeto para evitar recreaciones innecesarias
  return useMemo(
    () => ({
      tasks,
      setTasks,
      filteredTasks,
    }),
    [tasks, filteredTasks],
  );
};

export default useCalendarTasks;
